import aboutImg from "../../assets/images/about-img.jpg";

export default function About() {
  return (
    <div className="container relative py-16 md:py-36 flex-col flex">
      <div className="gap-[64px] lg:gap-[164px] flex flex-col lg:flex-row lg:items-center">
        <div className="flex flex-col gap-4">
          <div className="md:hidden p-2 w-fit bg-[#e6f1ff] rounded-md justify-center items-center gap-2 inline-flex">
            <div className="whitespace-nowrap text-[#2b8cff] text-base font-medium font-secondary leading-[19px]">
              ABOUT
            </div>
          </div>
          <img
            src={aboutImg}
            alt="Frame 38"
            className="w-auto object-contain"
          />
        </div>
        <div className="flex-col justify-start items-start gap-4 inline-flex max-w-[576px]">
          <div className="self-stretch flex-col justify-start items-start gap-2 flex">
            <div className="hidden md:block p-2 bg-[#e6f1ff] rounded-md justify-center items-center gap-2 inline-flex">
              <div className="whitespace-nowrap text-[#2b8cff] text-base font-medium font-secondary leading-[19px]">
                ABOUT
              </div>
            </div>
            <div className="self-stretch text-white text-2xl md:text-[32px] font-semibold font-primary leading-[41.60px]">
              Meet Charles Bell
            </div>
          </div>
          <div className="self-stretch text-gray-50 md:text-lg font-light font-primary leading-[27px] tracking-[0.01em]">
            Charles Bell is a dedicated business consultant holding a Lean Six
            Sigma Master Black Belt certification, an MBA, and an MS in
            Operations Management. He specializes in operational efficiency
            projects across cosmetics manufacturing, ammunition manufacturing,
            and industrial refrigeration — helping capital-intensive facilities
            eliminate waste, raise throughput, and strengthen regulatory
            compliance. Currently pursuing an MS in Financial Planning and
            Counseling at the University of Alabama (expected completion
            December 2026), Charles integrates strategic financial acumen with
            operational excellence. He also holds a life insurance license in
            Arkansas.
          </div>
        </div>
      </div>
      <img
        src="https://storage.googleapis.com/uxpilot-auth.appspot.com/113049385656753869919/Rectangle1-17375161-56d7-4966-9934-eeea32dd825e.svg"
        alt="Rectangle 1"
        className="absolute top-0 right-[22px] w-10 md:w-auto"
      />
    </div>
  );
}
